import { Frame } from '@/store';
import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { ContextMenuComponent } from '@/App/Main/Frame/ContextMenu/script';
import { nedConeSearchUrl } from '@/modules/ExternalServicesModule/ned';

@Component
export default class extends Vue {
  @Inject('contextMenu')
  contextMenu!: ContextMenuComponent

  @Prop({ required: true })
  frame!: Frame

  simbad(arcmin: number) {
    const { a, d } = this.contextMenu.coord()
    // tslint:disable-next-line:max-line-length
    const url = `http://simbad.u-strasbg.fr/simbad/sim-coo?Coord=${a.deg}+${d.deg}&CooFrame=FK5&CooEpoch=2000&CooEqui=2000&CooDefinedFrames=none&Radius=${arcmin}&Radius.unit=arcmin&submit=submit+query`
    window.open(url)
  }

  ned(arcmin: number) {
    const { a, d } = this.contextMenu.coord()
    window.open(nedConeSearchUrl(a.deg, d.deg, arcmin))
  }
}
